import { z } from "zod";

const regexMobile = /^\+?\d{6,15}$/;

export const missingCellphoneFormSchema = z.object({
  cell_phone: z
    .string()
    .min(1, { error: "Le numéro de mobile est obligatoire." })
    .regex(regexMobile, { error: "Le numéro de mobile est invalide." }),

  dialing_code: z.string().min(1, { error: "L'indicatif est obligatoire." }),
  allow_show_cell_phone: z.boolean(),
  allow_use_cell_phone: z.boolean(),
});
export type MissingCellphoneFormData = z.infer<typeof missingCellphoneFormSchema>;
